export default "__VITE_ASSET__BlIQQHdh__"